import { render } from "./swiperTool.vue?vue&type=template&id=32b5e830&scoped=true"
import script from "./swiperTool.vue?vue&type=script&lang=js"
export * from "./swiperTool.vue?vue&type=script&lang=js"

import "./swiperTool.vue?vue&type=style&index=0&id=32b5e830&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b5e830"]])

export default __exports__